import { OutboundAuthApiError, type OutboundAuthContainerResponse } from './types';

/**
 * AaidcontainerbyaaidandcontaineridGet
 * https://bitbucket.org/atlassian/outbound-auth/src/10269590a6d61b051f11104231a3159e4a5fc49a/docs/content/platform/outbound-auth/swagger.yaml?at=master#lines-1392
 * @param aaid - Atlassian Account ID
 * @param containerId - Container UUID
 * @param serviceKey - Optional service key to filter by
 * @returns Promise<OutboundAuthContainerResponse> - The API response
 */
export const fetchOutboundAuthDataInternal = async (
	aaid: string,
	containerId: string,
	serviceKey?: string,
): Promise<OutboundAuthContainerResponse> => {
	const queryParams = new URLSearchParams();
	if (serviceKey) {
		queryParams.append('serviceKey', serviceKey);
		// include=aaId - This bypasses token refresh and profile fetching operations. Adding include=accessToken can trigger token refresh from external providers, and omitting this include query parameter would result in displayName and avatarUrl being added by default to includeFields, which can trigger external API calls for profile data.
		queryParams.append('include', 'aaid');
	}

	const queryString = queryParams.toString();
	const url = `/gateway/api/outbound-auth/aaId/${aaid}/container/${containerId}${queryString ? `?${queryString}` : ''}`;

	const response = await fetch(url, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	});

	if (!response.ok) {
		throw new OutboundAuthApiError('Failed to fetch outbound auth by aaid and container id');
	}

	return (await response.json()) as OutboundAuthContainerResponse;
};
